jQuery("#nav-top").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
});
new Swiper("#swiper-btn", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },
  loop: true,
});
new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },
  loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
});

let swiper = new Swiper("#sp-swiper", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },

  loop: true,
  pagination: {
    el: ".pagination1",
    type: "bullets",
    clickable: true,
  },
});

let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let size = $('#sp-size div.active').attr('data-val')
  return prods.find(item=> item.option1 == color && item.option3 == size)
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .brand .num").html(off_font);
}
$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})

$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice()
  }
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice()
});

let spImgList1 = [
  "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-b1.png",
  "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-b2.png",
  "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-b3.png",
  "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-b4.png",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList1);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") +
            -215 * $("div#root").css("zoom"),
          // behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let spImgLists = [
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-21-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-21-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-21-5.png",
    ],
    text: "#01 White",
    color: "rgb(18, 18, 18, 0.5)",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-02-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-02-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-02-5.png",
    ],
    text: "#02 Orange",
    color: "#f3701f",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-03-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-03-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-03-5.png",
    ],
    text: "#03 Mint Green",
    color: "#8ff1cb",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-04-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-04-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-04-5.png",
    ],
    text: "#04 Blue",
    color: "#6caac3",
  },
  // {
  //   img: [
  //     "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-05-1.png",
  //     "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-05-3.png",
  //     "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-05-5.png",
  //   ],
  //   text: "#05 Cerulean blue ",
  //   color: "#015e89",
  // },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-06-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-06-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-06-5.png",
    ],
    text: "#05 Black ",
    color: "#1c1c1d",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-07-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-07-3.png?v=1718686246",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-07-5.png",
    ],
    text: "#06 Red",
    color: "#8c0306",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-08-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-08-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-08-5.png",
    ],
    text: "#07 Blue Gray",
    color: "#465b68",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-09-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-09-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-09-5.png",
    ],
    text: "#08 Dark Green",
    color: "#076749",
  },
    {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-10-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-10-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-10-5.png",
    ],
    text: "#09 Dark Blue",
    color: "#005ca8",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-11-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-11-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-11-5.png",
    ],
    text: "#10 Light Green",
    color: "#5c8a6f",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-12-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-12-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-12-5.png",
    ],
    text: "#11 Middle Green",
    color: "#008244",
  },

 {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-13-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-13-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-13-5.png",
    ],
    text: "#12 Yellow",
    color: "#ffd17c",
  },

  
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-14-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-14-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-14-5.png",
    ],
    text: "#13 Pink",
    color: "#f6bfd0",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-15-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-15-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-15-5.png",
    ],
    text: "#14 Light Gray",
    color: "#c7c9ca",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-16-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-16-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-16-5.png",
    ],
    text: "#15 Light Blue",
    color: "#a4dffb",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-17-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-17-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-17-5.png",
    ],
    text: "#16 Dark Brown",
    color: "#2d0a02",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-18-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-18-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-18-5.png",
    ],
    text: "#17 Bright Orange",
    color: "#f7941d",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-19-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-19-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-19-5.png",
    ],
    text: "#18 Sky Blue",
    color: "#40bfef",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-071-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-071-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-071-5.png",
    ],
    text: "#19 Reddish Brown",
    color: "#7b2800",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-01-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-01-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-01-5.png",
    ],
    text: "#20 Milky White",
    color: "rgb(18, 18, 18, 0.5)",
  },
 
    {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-22-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-22-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-22-5.png",
    ],
    text: "#21 Bright Yellow",
    color: "#f8db33",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-23-1.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-23-3.png",
      "https://cdn.shopify.com/s/files/1/0752/9975/0173/files/20240617-p-23-5.png",
    ],
    text: "#22 Gray",
    color: "#585a5e",
  },
];
$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项
  let colorOptions = $("#sp-color .option.active").index();
  let sizeOptions = $("#sp-size .option.active").index();
    let ml = $("#sp-size .option.active").attr("data-ml");
  $("#text-ml").text(ml)
  if(ml == '2000ml') {
    $("#text-ml").css('right','190px')
  } else {
     $("#text-ml").css('right','102px')
  }

  let img0 = $(".p-img");
  img0[0].src = spImgLists[colorOptions].img[sizeOptions];
  // img0[0].src = spImgLists[colorOptions].img[1];
  $(".sp-brand").html(spImgLists[colorOptions].text);
  $("#sp-color .option").css("borderColor", "#fff");
  $("#sp-color .option.active").css(
    "borderColor",
    spImgLists[colorOptions].color
  );
  changePrice()
});
// 购物车加购动效
$(".cart-btn").click(function () {
  $(this).children("img").addClass("on");
  $(".sp-header-top .sp-cart .num").show();
  setTimeout(function () {
    $(".cart-btn").children("img").removeClass("on");
  }, 500);
  $(".sp-header-top .sp-cart").addClass("on");
  setTimeout(function () {
    $(".sp-header-top .sp-cart").removeClass("on");
  }, 500);
});


$(".product-part .cart-btn").click(function () {
  var data = {
    id: getCur().id,
    quantity: $('#calcNumber').val(),
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $("#cardNum").html(result.item_count);
      });
    },
    dataType: "json",
  });

  var img = $(".product-part .p-img");
  var flyer = img[0].cloneNode(true);
  flyer.classList.add("sp-clone");

  $("#shopping").append(flyer);
  $(".sp-clone").css({
    width: img[0].width,
    height: img[0].height,
    position: "fixed",
    top: img[0].offsetTop,
    left: img.offset().left,
    "z-index": "99",
  });

  let finish = $(".sp-cart");
  $(".sp-clone").animate(
    {
      top: finish[0].offsetTop + $(".sp-nav-top").height(),
      left: finish[0].offsetLeft + finish.width() / 2,
      width: 50, // 结束时的大小，根据需要调整
      height: 50, // 结束时的大小，根据需要调整
      opacity: 0.4,
    },
    500,
    "linear",
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0
      );
    }
  );
});
